module.exports = __webpack_public_path__ + "static/media/sort-03.dc46ce9f.svg";